import { useEffect } from "react";
import { Link, useRouteError } from "react-router-dom";

import { Button } from "../ui/Button";
import { Card } from "../ui/Card";

/**
 * What a screen shows in its place when drawing it failed. The frame (navigation, status) stays, so the
 * person can go somewhere else. The technical reason is not shown; it goes to the browser's console.
 */
export function RouteError() {
  const error = useRouteError();
  useEffect(() => {
    console.error("A screen could not be drawn", error);
  }, [error]);
  return (
    <Card aria-labelledby="route-error-title" role="alert">
      <h1 id="route-error-title">This screen could not be shown</h1>
      <p>Something went wrong while drawing it. You can try again, or go to the home screen.</p>
      <div className="row">
        <Button variant="primary" onClick={() => window.location.reload()}>
          Try again
        </Button>
        <Link to="/">Go to the home screen</Link>
      </div>
    </Card>
  );
}
